<script setup>

import KitModalHeader from "@/components/global-themed/ui/modals/KitModalHeader.vue";
import ModalSubText from "@/components/global-themed/ui/modals/ModalSubText.vue";
import ModalHeading from "@/components/global-themed/ui/modals/ModalHeading.vue";
import ModalHeader from "@/components/global-themed/ui/modals/ModalHeader.vue";
import BaseModal from "@/components/global-themed/BaseModal.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import ModalContentWrapper from "@/components/global-themed/ui/modals/ModalContentWrapper.vue";

const emit = defineEmits(['close', 'dismiss', 'confirm']);

defineProps({
  heading: {
    type: String,
    required: true,
  },
  subText: {
    type: String,
    required: true,
  },
  cancelText: {
    type: String,
    required: true,
  },
  confirmText: {
    type: String,
    required: true,
  }
})

const handleDismiss = () => {
  emit('close');
  emit('dismiss');
};
</script>

<template>
  <Teleport
    to=".tailwind"
  >
    <BaseModal
      modal-class="tw-w-[800px]"
      @close="handleDismiss"
    >
      <ModalContentWrapper>
        <KitModalHeader>
          <ModalHeader>
            <ModalHeading>{{ heading }}</ModalHeading>

            <ModalSubText>
              {{ subText }}
              <slot name="default" />
            </ModalSubText>
          </ModalHeader>
        </KitModalHeader>
        <div class="tw-flex tw-items-center tw-justify-between tw-gap-4">
          <DefaultButton
            variant="primary-inverted"
            @click="emit('close')"
          >
            {{ cancelText }}
          </DefaultButton>
          <DefaultButton
            @click="emit('confirm')"
          >
            {{ confirmText }}
          </DefaultButton>
        </div>
      </ModalContentWrapper>
    </BaseModal>
  </Teleport>
</template>